(function IIFE() {
    'use strict';

    /////////////////////////////

    function FeedUserSubscriptionFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/feed/user/subscription/:methodKey', {}, {
            list: {
                isArray: false,
                method: 'GET',
                params: {
                    methodKey: 'list',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('FeedUserSubscriptionFactory', FeedUserSubscriptionFactory);
})();
